import { buildQueryKey } from '@webapp/core/utils/react-query/buildQueryKey'
import { type ListCreditCardAccountsParams } from '@webapp/modules/accounts-payable/business-logic/interfaces/ICreditCardAccountRepository'
import { creditCardAccountRepository } from '../data-access/repositories/CreditCardAccountRepository'

// Shares platform/banking's prefix so its card mutations invalidate these too;
// the 'ap' segment keeps the entries apart, since both map the same endpoint
// into different entities.
const base = ['credit-card-accounts', 'ap']
export const CREDIT_CARD_ACCOUNT_LIST_BASE_KEY = [...base, 'list']

export const creditCardAccountQueries = {
  list: (params: ListCreditCardAccountsParams) => ({
    queryKey: buildQueryKey([...CREDIT_CARD_ACCOUNT_LIST_BASE_KEY, params]),
    queryFn: () => creditCardAccountRepository.list(params),
  }),
  detail: (id: number) => ({
    queryKey: buildQueryKey([...base, 'detail', id]),
    queryFn: () => creditCardAccountRepository.getById(id),
  }),
}
